import { CustomizationDto, CustomizationDtoProcessStatus } from './../../../client-core/dtos/customization.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-recomended-section',
  templateUrl: './recomended-section.component.html',
  styleUrls: ['./recomended-section.component.scss']
})
export class RecomendedSectionStatusComponent implements OnInit {
  @Input() status: CustomizationDtoProcessStatus;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/recomended-section/recomended-section.component.ts